var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "switch-btn",
                on: { click: _vm.switch_show_header }
              },
              [_vm._v("\n            切換表格單位\n        ")]
            )
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                search: slot_props.search,
                should_draw_diagram_header: _vm.should_draw_diagram_header,
                enable_diagram_slot: true,
                show_description_dialog_btn: false,
                is_show_chart_dialog_parent: _vm.is_show_chart_dialog
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time,
                "open-chart": _vm.assign_chart_component,
                "update:is_show_chart_dialog_parent": function($event) {
                  _vm.is_show_chart_dialog = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "diagram_dialog",
                    fn: function(ref) {
                      var close_dialog = ref.close_dialog
                      return [
                        _vm.history_data_loaded && _vm.is_show_chart_dialog
                          ? [
                              _c("MonitorTide", {
                                attrs: {
                                  timeseries_data: _vm.history_data,
                                  default_variable: _vm.tide_history_option
                                },
                                on: { "close-chart-dialog": close_dialog }
                              })
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }